import axios from '@axios'

export default {
  namespaced: true,
  state: {
    dialog: false,
    temporary: false,
    employees: [],
    selectEmployees: [],

    categoriesServices: [],
    selectCategoriesServices: [],

    services: [],
    selectServices: [],

    scheduleStatus: [],
    selectScheduleStatus: [],

    offerStatus: [],
    selectOfferStatus: [],

    suppliers: [],
    selectSuppliers: [],

    selectedPurchaseOrderType: [],
    purchaseOrderTypes: [],
    selectedPurchaseOrderStatus: [],
    purchaseOrderStatus: [],
  },
  getters: {
    getDialogDrawerFilter(state) { return state.dialog },
    getTemporary(state) { return state.temporary },

    // employee
    getSelectEmployees(state) { return state.selectEmployees },
    getEmployees(state) { return state.employees },

    // categoria de service
    getSelectCategoriesServices(state) { return state.selectCategoriesServices },
    getCategoriesServices(state) { return state.categoriesServices },

    // service
    getSelectServices(state) { return state.selectServices },
    getServices(state) { return state.services },

    //
    getScheduleStatus(state) { return state.scheduleStatus },
    getSelectScheduleStatus(state) { return state.selectScheduleStatus },

    // offer status
    getOfferStatus(state) { return state.offerStatus },
    getSelectOfferStatus(state) { return state.selectOfferStatus },

    // suppliers
    getSelectSuppliers(state) { return state.selectSuppliers },
    getSuppliers(state) { return state.suppliers },

    // tipo de pedido de compra selecionado (estoque)
    getSelectedPurchaseOrderType(state) { return state.selectedPurchaseOrderType },
    getPurchaseOrderTypes(state) { return state.purchaseOrderTypes },

    // status de pedido de compra selecionado (estoque)
    getSelectedPurchaseOrderStatus(state) { return state.selectedPurchaseOrderStatus },
    getPurchaseOrderStatus(state) { return state.purchaseOrderStatus },

    /**
     * retorna o payload dos filtros selecionados
     */
    getFilterPayload(state) {
      return {
        employees: state.selectEmployees,
        suppliers: state.selectSuppliers,
        categories_services: state.selectCategoriesServices,
        services: state.selectServices,
        schedule_status: state.selectScheduleStatus,
        offer_status: state.selectOfferStatus,
        purchase_order_type: state.selectedPurchaseOrderType,
        purchase_order_status: state.selectedPurchaseOrderStatus,

      }
    },
    getFiltersChip(state) {
      const filters = []

      if (state.selectEmployees.length > 0) {
        state.selectEmployees.forEach(item => {
          const employee = state.employees.find(emp => emp.id === item)

          filters.push({
            type: 'employee',
            text: employee.first_name,
            value: employee.id,
          })
        })
      }

      // categoria de serviços selecionados
      if (state.selectCategoriesServices.length > 0) {
        state.selectCategoriesServices.forEach(item => {
          const category_service = state.categoriesServices.find(emp => emp.id === item)
          filters.push({
            type: 'category_service',
            text: category_service.name,
            value: category_service.id,
          })
        })
      }

      // serviços selecionados
      if (state.selectServices.length > 0) {
        state.selectServices.forEach(item => {
          const service = state.services.find(emp => emp.id === item)

          filters.push({
            type: 'service',
            text: service.name,
            value: service.id,
          })
        })
      }

      // status de agendamentos
      if (state.selectScheduleStatus.length > 0) {
        state.selectScheduleStatus.forEach(item => {
          const status = state.scheduleStatus.find(emp => emp.value == item)
          filters.push({
            type: 'schedule_status',
            text: status.text,
            value: status.value,
          })
        })
      }

      // status de ofertas
      if (state.selectOfferStatus.length > 0) {
        state.selectOfferStatus.forEach(item => {
          const status = state.offerStatus.find(emp => emp.value === item)
          filters.push({
            type: 'offer_status',
            text: status.text,
            value: status.value,
          })
        })
      }

      // fonecedores
      if (state.selectSuppliers.length > 0) {
        state.selectSuppliers.forEach(item => {
          const supplier = state.suppliers.find(emp => emp.id === item)

          filters.push({
            type: 'supplier',
            text: supplier.name,
            value: supplier.id,
          })
        })
      }

      // tipo de pedido de compra (estoque)
      if (state.selectedPurchaseOrderType.length > 0) {
        state.selectedPurchaseOrderType.forEach(item => {
          const type = state.purchaseOrderTypes.find(emp => emp.value === item)

          filters.push({
            type: 'purchase_order_type',
            text: type.text,
            value: type.value,
          })
        })
      }

      // status de pedido de compra (estoque)
      if (state.selectedPurchaseOrderStatus.length > 0) {
        state.selectedPurchaseOrderStatus.forEach(item => {
          const type = state.purchaseOrderStatus.find(emp => emp.value === item)

          filters.push({
            type: 'purchase_order_status',
            text: type.text,
            value: type.value,
          })
        })
      }

      return filters
    },

  },
  mutations: {
    setDialogDrawerFilter(state, value) { state.dialog = value },
    setTemporary(state, value) { state.temporary = value },

    // employee
    setSelectEmployees(state, value) { state.selectEmployees = value },
    setEmployees(state, value) { state.employees = value },

    // supplier
    setSelectSuppliers(state, value) { state.selectSuppliers = value },
    setSuppliers(state, value) { state.suppliers = value },

    // service
    setSelectServices(state, value) { state.selectServices = value },
    setServices(state, value) { state.services = value },

    // categoria de serviços
    setSelectCategoriesServices(state, value) { state.selectCategoriesServices = value },
    setCategoriesServices(state, value) { state.categoriesServices = value },

    // status de agendamentos
    setSelectScheduleStatus(state, value) { state.selectScheduleStatus = value },
    setScheduleStatus(state, value) { state.scheduleStatus = value },

    // status de ofertas
    setSelectOfferStatus(state, value) { state.selectOfferStatus = value },
    setOfferStatus(state, value) { state.offerStatus = value },

    /**
     * define o tipo de pedido de compra selecionado (estoque)
     */
    setSelectedPurchaseOrderType(state, type) { state.selectedPurchaseOrderType = type },
    setPurchaseOrderTypes(state, types) { state.purchaseOrderTypes = types },

    /**
     * define o status de pedido de compra selecionado (estoque)
     */
    setSelectedPurchaseOrderStatus(state, status) { state.selectedPurchaseOrderStatus = status },
    setPurchaseOrderStatus(state, status) { state.purchaseOrderStatus = status },

    clearFilters(state) {
      state.selectEmployees = []
      state.selectCategoriesServices = []
      state.selectSuppliers = []
      state.selectServices = []
      state.selectScheduleStatus = []
      state.selectOfferStatus = []
      state.selectedPurchaseOrderType = []
      state.selectedPurchaseOrderStatus = []
    },

    removeChip(state, chip) {
      if (chip.type === 'employee') {
        state.selectEmployees = state.selectEmployees.filter(item => item !== chip.value)
      }
      if (chip.type === 'service') {
        state.selectServices = state.selectServices.filter(item => item !== chip.value)
      }
      if (chip.type === 'category_service') {
        state.selectCategoriesServices = state.selectCategoriesServices.filter(item => item !== chip.value)
      }
      if (chip.type === 'schedule_status') {
        state.selectScheduleStatus = state.selectScheduleStatus.filter(item => item !== chip.value)
      }
      if (chip.type === 'offer_status') {
        state.selectOfferStatus = state.selectOfferStatus.filter(item => item !== chip.value)
      }
      if (chip.type === 'supplier') {
        state.selectSuppliers = state.selectSuppliers.filter(item => item !== chip.value)
      }
      if (chip.type === 'purchase_order_type') {
        state.selectedPurchaseOrderType = state.selectedPurchaseOrderType.filter(item => item !== chip.value)
      }
      if (chip.type === 'purchase_order_status') {
        state.selectedPurchaseOrderStatus = state.selectedPurchaseOrderStatus.filter(item => item !== chip.value)
      }
    },

  },
  actions: {
    getFilterData() {
      return axios.get('/helper/drawer_filter')
    },
  },
}
